import React from 'react';

import { ThemingProps } from '@chakra-ui/styled-system';

export type ButtonGroupVariant =
  | 'attached'
  | 'attached-outline'
  | 'separated'
  | 'separated-outline'
  | 'chip';

// Context for button group
export const ButtonGroupContext = React.createContext<{
  variant: ButtonGroupVariant;
  size: 'xs' | 'sm' | 'md' | 'lg';
  colorScheme: ThemingProps['colorScheme'];
  isDisabled: boolean;
  isFullWidth: boolean;
}>({
  variant: 'attached',
  size: 'md',
  colorScheme: 'blue',
  isDisabled: false,
  isFullWidth: false,
});

// Hook to use button group context
export const useButtonGroupContext = () => {
  const context = React.useContext(ButtonGroupContext);
  if (!context) {
    throw new Error('useButtonGroupContext must be used within a ButtonGroup');
  }
  return context;
};
